import React from 'react';
import { HelpCircle } from 'lucide-react';

const FixedHelpButton = ({ onShowHelp }) => {
  return (
    <button
      className="fixed-help-btn"
      onClick={onShowHelp}
      title="使用说明"
    >
      <HelpCircle size={20} className="text-white" />
    </button>
  );
};

export default FixedHelpButton;
